export default __webpack_public_path__ + "static/media/bookshelf.b2a29aad.png";